// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

// roots path
const ROOTS_AUTH = '/auth';
const ROOTS_BLOG = '/blog';
const ROOTS_TOOLS = '/tools';
const ROOTS_SHOP = '/shop';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ADMIN = '/manage';
const ROOTS_DEVELOPERS = '/developers';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  registerSuccess: path(ROOTS_AUTH, '/register-success'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  root: "/",
  empezar: '/empezar',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  mycolab: '/mycolab',
  about: '/about-us',
  contact: '/contact-us',
  privacy: '/privacy',
  terms: '/terms',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  communityGallery: '/community/photos',
  blog: {
    root: ROOTS_BLOG,
    view: (slug) => path(ROOTS_BLOG, `/post/${slug}`),
  },
  shop: {
    root: ROOTS_SHOP,
    view: (unique_code) => path(ROOTS_SHOP, `/products/${unique_code}`),
    checkout: path(ROOTS_SHOP, '/checkout'),
    checkoutSuccess: path(ROOTS_SHOP, '/checkout/success'),
    checkoutError: path(ROOTS_SHOP, '/checkout/error'),
    trackOrder: path(ROOTS_SHOP, '/track-order'),
  },
  tools: {
    root: ROOTS_TOOLS,
    calc: path(ROOTS_TOOLS, `/calc`),
    mushroom_map: path(ROOTS_TOOLS, `/mushroom-map`),
    quiz: path(ROOTS_TOOLS, `/quiz`),
    recipes: path(ROOTS_TOOLS, `/cultivation-recipes`),
    recipeDetail: (shortId) => path(ROOTS_TOOLS, `/cultivation-recipes/${shortId}`),
    wood_guide: path(ROOTS_TOOLS, `/wood-guide`),
    field_guide: path(ROOTS_TOOLS, `/contamination-guide`),
    tincture_calc: path(ROOTS_TOOLS, `/tincture-calc`),
  }
};



export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  admin: {
    root: path(ROOTS_DASHBOARD, '/admin'),
    jobs: path(ROOTS_DASHBOARD, '/admin/jobs'),
    brevo: path(ROOTS_DASHBOARD, '/admin/brevo'),
    products: path(ROOTS_DASHBOARD, '/admin/products'),
    imageapproval: path(ROOTS_DASHBOARD, '/admin/imageapproval'),
    ingredientapproval: path(ROOTS_DASHBOARD, '/admin/ingredientapproval'),
    varietyapproval: path(ROOTS_DASHBOARD, '/admin/varietyapproval'),
  },
  library: {
    root: path(ROOTS_DASHBOARD, '/library'),
  },
  mycolab: {
    root: path(ROOTS_DASHBOARD, '/mycolab'),
    organizations: path(ROOTS_DASHBOARD, '/mycolab/organizations'),
    recipes: path(ROOTS_DASHBOARD, '/mycolab/recipes'),
    recipeDetail: (id) => path(ROOTS_DASHBOARD, `/mycolab/recipes/${id}`),
    batches: path(ROOTS_DASHBOARD, '/mycolab/batches'),
    batchDetail: (id) => path(ROOTS_DASHBOARD, `/mycolab/batches/${id}`),
    stages: path(ROOTS_DASHBOARD, '/mycolab/stages'),
    monitoring: path(ROOTS_DASHBOARD, '/mycolab/monitoring'),
    alerts: path(ROOTS_DASHBOARD, '/mycolab/alerts'),
    notes: path(ROOTS_DASHBOARD, '/mycolab/notes'),
    archives: path(ROOTS_DASHBOARD, '/mycolab/archives'),
    sensors: path(ROOTS_DASHBOARD, '/mycolab/sensors'),
    apiKeys: path(ROOTS_DASHBOARD, '/mycolab/api-keys'),
    library: path(ROOTS_DASHBOARD, '/mycolab/strains'),
    strainDetail: (id) => path(ROOTS_DASHBOARD, `/mycolab/strains/${id}`),
    varietyDetail: (id) => path(ROOTS_DASHBOARD, `/mycolab/varieties/${id}`),
    settings: path(ROOTS_DASHBOARD, '/mycolab/settings'),
  },
  developers: {
    root: path(ROOTS_DASHBOARD, '/developers'),
    api: path(ROOTS_DASHBOARD, '/developers/api'),
  },
  gamification: {
    root: path(ROOTS_DASHBOARD, '/gamification'),
    achievements: path(ROOTS_DASHBOARD, '/gamification/achievements'),
    leaderboard: path(ROOTS_DASHBOARD, '/gamification/leaderboard'),
    challenges: path(ROOTS_DASHBOARD, '/gamification/challenges'),
  },
  shop: {
    root: path(ROOTS_DASHBOARD, '/shop'),
    checkout: path(ROOTS_DASHBOARD, '/shop/checkout'),
    products: path(ROOTS_DASHBOARD, '/shop/products'),
    orders: path(ROOTS_DASHBOARD, '/shop/orders'),
    memberships: path(ROOTS_DASHBOARD, '/shop/memberships'),
    pricing: path(ROOTS_DASHBOARD, '/shop/pricing'),
    membershipSuccess: path(ROOTS_DASHBOARD, '/shop/membership/success'),
    membershipError: path(ROOTS_DASHBOARD, '/shop/membership/error'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  support: {
    root: path(ROOTS_DASHBOARD, '/support'),
    chat: path(ROOTS_DASHBOARD, '/support/chat'),
    guide: path(ROOTS_DASHBOARD, '/support/guide'),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    store: path(ROOTS_DASHBOARD, '/user/store'),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
  },
  settings: {
    root: path(ROOTS_DASHBOARD, '/settings'),
    telegram: path(ROOTS_DASHBOARD, '/settings/telegram'),
    language: path(ROOTS_DASHBOARD, '/settings/language'),
  },
};

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  dashboard: path(ROOTS_ADMIN, '/dashboard'),
  users: {
    root: path(ROOTS_ADMIN, '/users'),
    list: path(ROOTS_ADMIN, '/users/list'),
    new: path(ROOTS_ADMIN, '/users/new'),
    edit: (id) => path(ROOTS_ADMIN, `/users/${id}/edit`),
  },
  products: path(ROOTS_ADMIN, '/products'),
  productsNew: path(ROOTS_ADMIN, '/products/new'),
  productsEdit: (id) => path(ROOTS_ADMIN, `/products/${id}/edit`),
  orders: path(ROOTS_ADMIN, '/orders'),
  brevo: path(ROOTS_ADMIN, '/brevo'),
  emailTest: path(ROOTS_ADMIN, '/email-test'),
  social: path(ROOTS_ADMIN, '/social'),
  telegram: path(ROOTS_ADMIN, '/telegram'),
  apiKeys: path(ROOTS_ADMIN, '/api-keys'),
  imageApproval: path(ROOTS_ADMIN, '/image-approval'),
  ingredientApproval: path(ROOTS_ADMIN, '/ingredient-approval'),
  varietyApproval: path(ROOTS_ADMIN, '/variety-approval'),
  jobs: path(ROOTS_ADMIN, '/jobs'),
  proManagement: path(ROOTS_ADMIN, '/pro-management'),
  systemDocs: path(ROOTS_ADMIN, '/system-docs'),
};

export const PATH_DEVELOPERS = {
  root: ROOTS_DEVELOPERS,
  api: path(ROOTS_DEVELOPERS, '/api'),
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
